import { ROUTES } from '@habity/constants';

export const isSearchLinkActive = (pathname: string) =>
  pathname === ROUTES.SEARCH.HOMES ||
  pathname === ROUTES.SEARCH.BUYERS ||
  pathname === ROUTES.SEARCH.BROKERS ||
  pathname === ROUTES.SEARCH.AREAS ||
  pathname === ROUTES.SEARCH.MUNICIPALITIES;

export const isChatLinkActive = (pathname: string) =>
  pathname.includes(ROUTES.CHAT);

export const isAccountLinkActive = (pathname: string) =>
  pathname === ROUTES.LOGIN ||
  pathname === ROUTES.DASHBOARD.ACCOUNT;

export const isSellLinkActive = (pathname: string) =>
  pathname.includes(ROUTES.SELL);

export const isBuyLinkActive = (pathname: string) =>
  pathname.includes(ROUTES.BUY);

export const isHomesLinkActive = (pathname: string) =>
  pathname === ROUTES.DASHBOARD.HOMES.INDEX ||
  pathname === ROUTES.DASHBOARD.SELLER.INDEX ||
  pathname === ROUTES.DASHBOARD.HOMES.EDIT_PATH;

export const isHomeSearchLinkActive = (pathname: string) =>
  pathname.includes(ROUTES.SEARCH.HOMES);

export const isBuyerSearchLinkActive = (pathname: string) =>
  pathname.includes(ROUTES.SEARCH.BUYERS);

export const isBrokerSearchLinkActive = (pathname: string) =>
  pathname.includes(ROUTES.SEARCH.BROKERS);

export const isBrokerLinkActive = (pathname: string) =>
  pathname === ROUTES.DASHBOARD.BROKER.INDEX;

export const isSearchHistoryLinkActive = (pathname: string) =>
  pathname === ROUTES.DASHBOARD.BUYER.INDEX;
